$('.buscarOposicion').keyup(function(){

    //lo de == 0 es para que si borran el input despus de una busqueda vuelva a tener todos los resultados.
    if($(this).val().length > 1 || $(this).val().length == 0){
        filtrarOposicionPorTexto();
    }
    
});


function filtrarOposicionPorTexto(){

    var textoOposicion = $('#search').val();  

    // esto nos dice en que pagina estamos para construir el enlace del boton
    var tipoEnlace = $('#tipo-url').val();
    var numRegistros = $('#_regxpag').val();
    var orden = $('#_orden').val();
    var pag = $('#pagina').val();


    jQuery.ajax({
        type: 'POST',
        async: true,
        url: rutajs+'lib/ajax.php',
        data : 'fn=getOposicionesPorTexto&sOposicion='+htmlspecialchars(textoOposicion)+'&limit='+numRegistros+'&sTipoEnlace='+tipoEnlace+'&_orden='+orden+'&_pag='+pag,
        success: function(data) {
            data = JSON.parse(data);
            // console.log(data.sql);
            
            // $('.sql').html(data.sql);
            $('.reg-async').html(data.oposiciones);
            $('.numero-resultados').html(data.registros);
            // $('.filtros').html(data.filtros);
            if(parseInt(data.numReg) < parseInt(numRegistros)) {
                $('.paginacion-dinamica').addClass('d-none');
            } else {
                $('.paginacion-dinamica').removeClass('d-none');
            }
        }
    });

}